import React, { useState } from "react";
import { Search, Minus, Plus, RotateCcw } from "lucide-react";
import { usePageZoom } from "../../hooks/usePageZoom";
import { useLanguage } from "../../contexts/LanguageContext";

/**
 * Translucent magnifier above the language switcher: open a small zoom panel.
 */
function PageZoomControl() {
  const { lang } = useLanguage();
  const { scale, zoomIn, zoomOut, reset, canZoomIn, canZoomOut } = usePageZoom();
  const [open, setOpen] = useState(false);
  const hi = lang === "hi";

  return (
    <div className="relative flex flex-col items-center">
      {open && (
        <div
          className="absolute bottom-full mb-2 rounded-xl border border-white/40 bg-slate-800/70 backdrop-blur-md shadow-lg p-2 flex items-center gap-1"
          role="group"
          aria-label={hi ? "ज़ूम नियंत्रण" : "Zoom controls"}
        >
          <button
            type="button"
            onClick={zoomOut}
            disabled={!canZoomOut}
            className="w-9 h-9 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/15 disabled:opacity-35"
            aria-label={hi ? "ज़ूम आउट" : "Zoom out"}
          >
            <Minus size={16} />
          </button>
          <span className="min-w-[2.75rem] text-center text-xs font-semibold text-white/90 tabular-nums">
            {Math.round(scale * 100)}%
          </span>
          <button
            type="button"
            onClick={zoomIn}
            disabled={!canZoomIn}
            className="w-9 h-9 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/15 disabled:opacity-35"
            aria-label={hi ? "ज़ूम इन" : "Zoom in"}
          >
            <Plus size={16} />
          </button>
          <button
            type="button"
            onClick={reset}
            className="w-9 h-9 rounded-lg flex items-center justify-center text-white/90 hover:bg-white/15"
            aria-label={hi ? "रीसेट" : "Reset zoom"}
          >
            <RotateCcw size={15} />
          </button>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="bg-slate-700/55 text-white w-10 h-10 sm:w-12 sm:h-12 rounded-lg shadow-md backdrop-blur-sm flex items-center justify-center hover:bg-slate-800/70 transition-colors duration-150"
        aria-expanded={open}
        aria-label={hi ? "पेज ज़ूम" : "Page zoom"}
      >
        <Search size={18} />
      </button>
    </div>
  );
}

export default PageZoomControl;
